module.exports = __webpack_public_path__ + "static/img/entrance.aee7f49.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/selfMadeGame/entrance.gif
// module id = P/hG
// module chunks = 0